import { render, staticRenderFns } from "./SelfMonitoringReportsDetailsActions.vue?vue&type=template&id=d121e790&scoped=true"
import script from "./SelfMonitoringReportsDetailsActions.vue?vue&type=script&lang=ts"
export * from "./SelfMonitoringReportsDetailsActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d121e790",
  null
  
)

export default component.exports